<wiz-text-input #mainInput [wizValidator]="validateDefaultLanguage()"
  [manageModel]=false width="100%"
  [wizLabel]="wizLabel"
  [wizRightIcon]="'flag'"
  [wizMandatory]="wizMandatory"
  [wizPlaceholder]="wizPlaceholder"
  [wizShowErrors]="wizShowErrors"
  [wizMaxChars]="wizMaxChars"
  [wizShowLabel]="wizShowLabel"
  [wizDisabled]="wizDisabled"
  ></wiz-text-input>
